// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parseImageUrl from "@insite/mobius/utilities/parseImageUrl";
import { typographyInvertColorStyles } from "@store/Themes/common/mixins/typography";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps, HasCategoryContext {}

const enum fields {
    invertColor = "invertColor",
}

export interface CategoryHeaderStyles {
    container?: InjectableCss;
    content?: InjectableCss;
}

export const categoryHeaderStyles: CategoryHeaderStyles = {
    container: {
        css: css`
            background-size: cover;
            padding-top: ${pxToRem(45)};
            padding-bottom: ${pxToRem(60)};

            ${breakpoint("sm")} {
                padding-top: ${pxToRem(90)};
                padding-bottom: ${pxToRem(90)};
            }
        `,
    },
    content: {
        css: css`
            ${siteWidthStyles()}
        `,
    },
};

const CategoryHeader: FC<Props> = ({ id, fields, category }) => {
    if (!category) {
        return null;
    }
    const { invertColor } = fields;
    const styles = mergeProps<CategoryHeaderStyles>(categoryHeaderStyles, {
        container: {
            css: css`
                ${cssProp("background-image", category.largeImagePath, x => `url(${parseImageUrl(x).url})`)}
                ${invertColor && typographyInvertColorStyles()}
            `,
        },
    });
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.content}>
                <Zone contentId={id} zoneName="Content" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: withCategory(CategoryHeader),
    definition: {
        group: "Category Details",
        displayName: "Category Header",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.invertColor,
                displayName: "Invert Text Color",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
        ],
    },
};
export default widgetModule;
